<template>
  <div class="py-3">
    <page-title title="Clients" />
    <hr />
    <filtered-table :settings="tableSettings" @rowClicked="onRowClicked">
    </filtered-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ClientList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        endpoint: '/api/client',
        includes: [
          'applicationUser',
          'subscriptionUser',
          'subscriptionUser.applicationUser'
        ],
        columns: [
          {
            key: 'id',
            name: 'ID',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'applicationUser.displayName',
            name: 'Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'applicationUser.email',
            name: 'Email Address',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'applicationUser.phoneNumber',
            name: 'Phone Number',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'subscriptionUser.applicationUser.displayName',
            name: 'Subscriber Name',
            visible: true,
            sortable: true,
            filter: 'text'
          }
        ],
        getDefaultFilter: function () {
          return '';
        }
      }
    }
  },
  methods: {
    onRowClicked: function (item, context) {
      this.$router.push('/subscriber/client/' + item.id);
    }
  },
  mounted () {
  }
};
</script>